import React from 'react';
import CKEditor from "react-ckeditor-component";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { this.props.history } from 'react-router';
import * as SVGICONS from '../../images/img/images';
import * as SpecialistBlogActions from '../../actions/SpecialistblogActions';
import validator from './../common/validator.js';
import autoBind from 'auto-bind';
import * as constant from '../../constants/constant';
import * as dashboardActions from "../../actions/dashboardActions";
// import $ from 'jquery'
// import '../../styles/css/style.css';

class SpecialistBlog extends React.Component {
	constructor(props, context) {
		// CKEditor.replace('editor1', {
		// 	extraPlugins: 'imageuploader'
		// });
		super(props, context);
		autoBind(this);
		this.state = {
			oldFile: '',
			imagePreviewUrl: '',
			blogTitle: { value: '', isValid: true, message: '' },
			description: { value: '', isValid: true, message: '' },
			file: { value: '', isValid: true, message: '' },
			content: '',
			fileOriginalName: '',
			logoutButton: false,
			DescforCond: '',
		}
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this);
		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	
	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle(e, menuClicked) {
		var windowWidth = $(window).width();
		if (windowWidth <= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-open");
			} else {
				$("body").toggleClass("sidebar-open");
			}
		}

		if (windowWidth >= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-collapse");
			} else if (e == false) {
				$("body").toggleClass("sidebar-collapse");
			}
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	onChange(evt) {
		var newContent = evt.editor.getData();
		this.setState({
			content: newContent,
			description: { value: newContent, isValid: true, message: '' }
		})
		if (newContent == '') {
			this.setState({ description: { value: newContent, isValid: true, message: 'Description is required' } })
		}
	}
	updateContent(newContent) {
		this.setState({
			content: newContent
		})
	}
	componentWillMount() {
		if (this.props.match.params.blogId) {
			let blogId = this.props.match.params.blogId;
			this.props.actions.getSpecialistBlogById(blogId);
		} else {
			
			this.setState({
				blogTitle: { value: '', isValid: true, message: '' },
				description: { value: '', isValid: true, message: '' }
			})
		}
	}
	componentWillReceiveProps(nextProps) {
		
		if (this.props.match.params.blogId) {
			if (nextProps.blogData && nextProps.blogData.success) {
				this.setState({
					oldFile: nextProps.blogData.listImage,
					file: { value: nextProps.blogData.listImage ? '' : this.state.file.value, isValid: true, message: '' },
					description: { value: nextProps.blogData.description ? nextProps.blogData.description : this.state.description.value, isValid: true, message: '' },
					content: nextProps.blogData.description ? nextProps.blogData.description : '',
					DescforCond: nextProps.blogData.description ? nextProps.blogData.description : '',
					blogTitle: { value: nextProps.blogData.blogTitle ? nextProps.blogData.blogTitle : this.state.documentTypeId.value, isValid: true, message: '' },
					fileOriginalName: (nextProps.blogData && nextProps.blogData.ImageOriginalName) ? nextProps.blogData.ImageOriginalName : ''
				})
			}

		}
		// else {
		// 	this.setState({
		// 		spinner: false,
		// 		file: { value: '', isValid: true, message: '' },
		// 		blogTitle: { value: '', isValid: true, message: '' },
		// 		description: { value: '', isValid: true, message: '' },
		// 		content: '',

		// 	})
		// 	document.getElementById('blogTitle').value = ''
		// 	// document.getElementById('description').value = ''
		// 	document.getElementById('brosepic').value = ''
		// }
	}
	componentDidMount() {

	}
	reSetBlogForm() {
		// debugger;
		
		this.setState({
			oldFile: '',
			imagePreviewUrl: '',
			file: { value: '', isValid: true, message: '' },
			blogTitle: { value: '', isValid: true, message: '' },
			description: { value: '', isValid: true, message: '' },
			fileOriginalName: '',
			content: ''
		})
		document.getElementById('blogTitle').value = ''
		// document.getElementById('description').value = ''
		document.getElementById('brosepic').value = ''
	}
	addSpecialistBlog(event) {
		event.preventDefault();
		var state = this.state;
		
		if (!validator.isValid(state.file.value) && this.state.oldFile == '') {
			state.file.isValid = false;
			state.file.message = 'Image is required';
			this.setState({ file: { value: '', isValid: false, message: 'Image is required' } });
		} else {
			state.file.isValid = true;
			state.file.message = '';
			this.setState({ file: { value: state.file.value, isValid: true, message: '' } });
		}
		if (!validator.isValid(state.blogTitle.value)) {
			state.blogTitle.isValid = false;
			state.blogTitle.message = 'Blog Name name is required';
			this.setState({ blogTitle: { value: '', isValid: false, message: 'Blog Name is required' } });
		} else {
			state.blogTitle.isValid = true;
			state.blogTitle.message = '';
			this.setState({ blogTitle: { value: state.blogTitle.value, isValid: true, message: '' } });
		}
		if (!validator.isValid(state.description.value)) {
			state.description.isValid = false;
			state.description.message = 'Description is required';
			this.setState({ description: { value: '', isValid: false, message: 'Description is required' } });
		} else {
			state.description.isValid = true;
			state.description.message = '';
			this.setState({ description: { value: state.description.value, isValid: true, message: '' } });

		}
		
		if ((this.state.file.value != '' || this.state.oldFile) && this.state.blogTitle.value != '' && this.state.description.value != '' && (this.state.file.message == '' || this.state.file.message == undefined) && (this.state.blogTitle.message == '' || this.state.blogTitle.message == undefined) && (this.state.description.message == '' || this.state.description.message == undefined)) {
			let healthTipsObj = {
				specialistId: localStorage.getItem('userId'),
				blogTitle: this.state.blogTitle.value,
				description: this.state.description.value,
				file: this.state.file.value ? this.state.file.value : this.state.oldFile
			}
			
			if (this.props.match.params.blogId) {
				healthTipsObj.blogId = this.props.match.params.blogId
			}
			this.setState({ spinner: true })
			this.setState({
				file: { value: '', isValid: true, message: '' },
				blogTitle: { value: '', isValid: true, message: '' },
				description: { value: '', isValid: true, message: '' },
				imagePreviewUrl: '',
				// content: ''
			})
			document.getElementById('blogTitle').value = ''
			// document.getElementById('description').value = ''
			document.getElementById('brosepic').value = ''
			this.props.actions.addSpecialistBlog(healthTipsObj, this.props);


		}
	}
	onCancel() {
		this.props.history.push('/specialist/my-blog');
	}
	onChangeBlog(event) {
		let state = this.state;
		if (event.target.name == 'file') {
			state[event.target.name].value = event.target.files[0];
			state.fileOriginalName = event.target.files[0] ? event.target.files[0].name : ''
		}
		else {
			state[event.target.name].value = event.target.value;
		}


		this.resetValidationStates();
		if (event.target.name == "file") {
			if (event.target.files && event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					state.file.isValid = false;
					state.file.message = 'Please choose following format jpeg, jpg, png, gif';
					this.setState({ file: { value: '', isValid: false, message: 'Please choose following format jpeg, jpg, png, gif' }, imagePreviewUrl: '' });
				} else if (!validator.fileValidateSize(state.file.value)) {
					state.file.isValid = false;
					state.file.message = 'Image Size too large max size 10 mb';
					this.setState({ file: { value: '', isValid: false, message: 'Image Size too large max size 10 mb' }, imagePreviewUrl: '' });
				} else {
					let reader = new FileReader();
					let image = event.target.files[0];
					this.setState({ file: { value: event.target.files[0], isValid: true, message: '' } });
					reader.onloadend = () => {
						this.setState({
							imagePreviewUrl: reader.result
						});
					}

					reader.readAsDataURL(image);



					return true
				}
			} else {

				state.file.isValid = false;
				state.file.message = 'Image is required';
				this.setState({ file: { value: '', isValid: false, message: 'Image is required' } });
			}

		} else if (event.target.name == "blogTitle") {

			if (event.target.value.length > 0) {
				if (!validator.isValid(state.blogTitle.value)) {
					state.blogTitle.isValid = false;
					state.blogTitle.message = 'Not a valid Blog Name Name';
					this.setState({ blogTitle: { value: '', isValid: false, message: 'Not a valid Blog Name Name' } });

				} else {
					this.setState({ blogTitle: { value: state.blogTitle.value, isValid: true, message: '' } });

					return true
				}
			} else {
				state.blogTitle.isValid = false;
				state.blogTitle.message = 'Blog Name name is required';
				this.setState({ blogTitle: { value: '', isValid: false, message: 'Blog Name name is required' } });

			}
		} else if (event.target.name == "description") {

			if (event.target.value && event.target.value.length > 0) {
				if (!validator.isValid(state.description.value)) {
					state.description.isValid = false;
					state.description.message = 'Not a valid description';
					this.setState({ description: { value: '', isValid: false, message: 'Not a valid description' } });

				} else {
					this.setState({ description: { value: state.description.value, isValid: true, message: '' } });
					return true
				}
			} else {

				state.description.isValid = false;
				state.description.message = 'description is required';
				this.setState({ description: { value: '', isValid: false, message: 'description is required' } });

			}
		}
	}

	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state, () => {
			
		});
	}
	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		let imagePreviewUrl
		if (this.state.oldFile && this.state.imagePreviewUrl == '') {
			let folderName = constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + folderName + this.state.oldFile;
		} else {
			imagePreviewUrl = this.state.imagePreviewUrl;
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'
			}
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var sidebartoggle = true;
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button"> <img src={require('../../images/img/menu_list.svg')} alt="" onClick={this.toggle.bind(this, !sidebartoggle)} /> <span className="sr-only">Toggle navigation</span> </a>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<a href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </a>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<a

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li>
												<a href="#tab_1" data-toggle="tab" className="active show">Blog</a>
											</li>
										</ul>
										<form className="login-form" id="documentUploadForm" name="form" onSubmit={this.addSpecialistBlog.bind(this)}>
											<div className="row">
												<div className="col-md-12">
													<div className="tab-content tabother">
														<div className="bloginput">
															<div className="row">
																<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
																	<div className="boxMrgB">
																		<div className="row">
																			<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																				<div className="input-group inputBg email">
																					<span className="input-group-addon m-t-0">
																						<SVGICONS.BlogName />
																					</span>
																					{/* <input type="" className="form-control p-d-20" placeholder="Blog Name" /> */}
																					<input type="" className="form-control p-d-20" placeholder="Blog Name" id="blogTitle" name="blogTitle" onChange={this.onChangeBlog} value={this.state.blogTitle.value} />
																				</div>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.blogTitle.message}</span>
																			</div>
																			<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																				<div className="m-t-30">
																					{/* <textarea className="form-control boxblog " placeholder="Blog Details"></textarea> */}
																					{/* <textarea className="form-control boxblog" id="description" placeholder="Blog Details" name='description' value={this.state.description.value} onChange={this.onChangeBlog} /> */}
																					{this.props.match.params.blogId && this.state.DescforCond ?
																						<CKEditor
																							id="description"
																							activeClass="p10"
																							content={this.state.content}
																							events={{
																								"blur": this.onBlur,
																								"afterPaste": this.afterPaste,
																								"change": this.onChange
																							}}
																						/> : ''}
																					{!this.props.match.params.blogId ?
																						<CKEditor
																							// id="description"
																							activeClass="p10"
																							content={this.state.content}
																							events={{

																								"change": this.onChange
																							}}
																						/> : ''}
																				</div>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.description.message}</span>
																			</div>
																		</div>
																	</div>
																</div>


																<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
																	<div className="boxMrgBb">
																		<div className="row">
																			<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																				<div className="dropzone">
																					<img src={imagePreviewUrl} />
																					{/* <Link href="#"> */}
																					<input type="file" className="form-control" id="brosepic" style={{ "display": "none" }} name="file" onChange={this.onChangeBlog} />
																					{/* <input type="file" id="brosepic" style={{ "display": "none" }} /> */}
																					<div className={this.state.fileOriginalName != '' ? "broicon middtext blogimageremove " : 'broicon middtext'}>
																					<div className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg blogadd" data-title="Please choose following formats only jpeg, jpg, png, gif">
																							<label htmlFor="brosepic">
																								<i><SVGICONS.Browsepic /></i>
																								<p>
																								Click here to browse files</p>
																							</label>
																							</div>
																					</div>
																					<p style={{ marginTop: 6 }}>{this.state.fileOriginalName ? this.state.fileOriginalName : ''}</p>
																					{/* </Link> */}

																				</div>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.file.message}</span>
																			</div>

																			<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																				<div className="m-t-20 text-center">
																					<button type="submit" className="btn btn-square mr-5 btn-w-120" >Submit</button> 
																					{!this.props.match.params.blogId 
																					? <button type="button" onClick={this.reSetBlogForm} className="btn btn-square btn-w-120">Reset</button> 
																					: ''
																					}
																					{this.props.match.params.blogId 
																					? <button type="button" onClick={this.onCancel} className="btn btn-square btn-w-120">Cancel</button> 
																					: ''}
																				</div>
																			</div>

																		</div>
																	</div>
																</div>

																<div className="col-md-12 disclaimer_mysetting"><h3>Disclaimer</h3><p>By submitting this blog post, you affirm that the information given in this blog does not defame, identify or negatively portray any individual, any patients of Medfix, any employee or supplier, contractor or partner of Medfix</p><p>Additionally, you affirm that the advice or information given in the blog is honest and truthful, and a representation of current, accepted medical practices.  You are responsible for the content of blog posts as per the Terms and Conditions, Patient Confidentiality Agreement, and Privacy Policy.</p><p>Any deviations from these rules will be considered a serious matter and may result in Medfix terminating any agreement in place, including suspension of account.</p></div>


															</div>
														</div>
														{/* <div className="row">

														<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
															<div className="box-body table-responsive no-padding attachmentTable mr-0">
																<table className="table table-hover">
																	<tbody><tr>
																		<th>Sr. No.  </th>
																		<th>  Blog Name     </th>
																		<th>Creation date</th>
																		<th>Action </th>

																	</tr>
																		<tr>
																			<td>1 </td>
																			<td> Lorem ipsum dolor sit amet, consectetur adipiscing elit   </td>
																			<td>26-04-2018        </td>
																			<td><Link href="#" className="editlink"><i className="fa fa-pencil-square-o"></i></Link><Link href="#" className="deleteLink"><i className="fa fa-trash"></i></Link></td>
																		</tr>
																		<tr>
																			<td>1 </td>
																			<td> Lorem ipsum dolor sit amet, consectetur adipiscing elit   </td>
																			<td>26-04-2018        </td>
																			<td><Link href="#" className="editlink"><i className="fa fa-pencil-square-o"></i></Link><Link href="#" className="deleteLink"><i className="fa fa-trash"></i></Link></td>
																		</tr>
																		<tr>
																			<td>1 </td>
																			<td> Lorem ipsum dolor sit amet, consectetur adipiscing elit   </td>
																			<td>26-04-2018        </td>
																			<td><Link href="#" className="editlink"><i className="fa fa-pencil-square-o"></i></Link><Link href="#" className="deleteLink"><i className="fa fa-trash"></i></Link></td>
																		</tr>

																	</tbody></table>
															</div>
														</div>

													</div> */}
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div >
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		blogData: state.SpecialistBlog.blogData
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(SpecialistBlogActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistBlog);